
export const Button = ({ color, outline, children }) => {
    return (
        <div className={`button ${color} ${outline ? 'outline' : ''}`}>
            {children}
        </div>
    )
}
